module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='' + require("./serpHotelCard/serpHotelCard-js.html").apply(null,arguments) + '\r\n<div class="js-visible-banners-hotel-card">\r\n    <div class="js-componentsBanner"></div>\r\n    <div class="js-filterBanner"></div>\r\n    <div class="js-lotteryBanner"></div>\r\n    <div class="js-conditionalBanner"></div>\r\n    <div class="js-appBanner"></div>\r\n    <div class="js-lifeHackBanner"></div>\r\n    <div class="js-paylateBnr"></div>\r\n</div>\r\n';
}
return __p;
};
